import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <h3 className='text-secondary'>Copyright 2022 Upturn</h3>
        </div>
    );
};

export default Footer;